import { DeviceType } from 'src/types/DeviceType';
import { getDeviceCapability } from 'src/utils/deviceCatalogCache';

export const formatDeviceName = (input: string | DeviceType): string => {
  if (!input) return '';

  // Prefer the catalog display name; if the type isn't in the catalog (or it hasn't loaded yet), return
  // the raw device type.
  return getDeviceCapability(input.toString())?.displayName ?? input.toString();
};
